<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="card shadow-sm">
            <div class="card-body">
              <h1 class="h4 mb-2">Create Account</h1>
              <p class="help mb-3">
                New accounts are created as technicians by default. Supervisors can only be created by contacting your administrator.
              </p>

              <!-- Signup form -->
              <form @submit.prevent="handleSignup">
                <div class="mb-3">
                  <label class="form-label">Username</label>
                  <!-- Username input -->
                  <input v-model="form.username" type="text" class="form-control" autocomplete="username" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <!-- Email input -->
                  <input v-model="form.email" type="email" class="form-control" autocomplete="email" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Password</label>
                  <!-- Password input -->
                  <input v-model="form.password" type="password" class="form-control" autocomplete="new-password" required />
                </div>

                <!-- Error messages display -->
                <div v-if="errors.length" class="alert alert-danger py-2">
                  <ul class="mb-0 ps-3">
                    <li v-for="(e, idx) in errors" :key="idx">{{ e }}</li>
                  </ul>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                  <!-- Link to login page -->
                  <RouterLink to="/login" class="small">Already have an account?</RouterLink>
                  <!-- Submit button, disabled when loading -->
                  <button type="submit" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    Create Account
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "SignupView",
  data() {
    return {
      // Form fields for signup
      form: {
        username: "",
        email: "",
        password: "",
      },
      loading: false, // Loading state for form submission
      errors: [],     // Array to hold error messages
      api: new APIService(), // API service instance
    };
  },
  methods: {
    // Handles signup form submission
    async handleSignup() {
      this.errors = []; // Clear previous errors
      this.loading = true; // Set loading state to true
      try {
        // Call signup API with form data
        const res = await this.api.signup(this.form);
        // Optionally auto-login after successful signup
        await this.handleAutoLogin();
      } catch (err) {
        // Handle and display errors from API
        const data = err.response?.data;
        if (Array.isArray(data?.detail)) {
          this.errors = data.detail; // Set errors if they are in an array
        } else if (typeof data?.detail === "string") {
          this.errors = [data.detail]; // Set single error message
        } else {
          this.errors = ["Unable to create account."]; // Default error message
        }
      } finally {
        this.loading = false; // Reset loading state
      }
    },
    // Automatically logs in the user after signup
    async handleAutoLogin() {
      try {
        // Call login API with username and password
        const res = await this.api.login({
          username: this.form.username,
          password: this.form.password,
        });
        const { access, refresh } = res.data; // Extract tokens from response
        // Store tokens in localStorage
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);

        // Fetch and store current user account info
        const accountRes = await this.api.account(access);
        localStorage.setItem("currentUser", JSON.stringify(accountRes.data));

        // Redirect to OrdersList page
        this.$router.push({ name: "OrdersList" });
      } catch {
        // If login fails, redirect to Login page
        this.$router.push({ name: "Login" });
      }
    },
  },
};
</script>

<style scoped>
.help {
  color: #6c757d;
}
</style>
